import {Button, Icon, Typography} from '@sollapay/ui/components';
import {Trans, useTranslation} from 'react-i18next';

import type {FC} from 'react';

export interface ClarificationResubmittedProps {
  packageLabel: string;
  onDone: () => void;
}

export const ClarificationResubmitted: FC<ClarificationResubmittedProps> = ({
  packageLabel,
  onDone
}) => {
  const {t} = useTranslation('trustAccounts');

  return (
    <div
      data-slot="clarification-resubmitted"
      className="flex flex-col items-center px-6 py-14 text-center"
    >
      <div
        data-slot="icon"
        className="mb-4 flex size-14 items-center justify-center rounded-full bg-background-success text-text-success"
      >
        <Icon name="check" className="size-6" />
      </div>
      <Typography as="h3" size="xl" weight="semibold" className="whitespace-normal">
        {t('activation.clarification.resubmitted.title')}
      </Typography>
      <Typography as="p" size="sm" color="secondary" className="mt-1.5 whitespace-normal">
        <Trans
          t={t}
          i18nKey="activation.clarification.resubmitted.description"
          values={{package: packageLabel, status: t('activation.packageStatus.inReview')}}
          components={{status: <b />}}
        />
      </Typography>
      <Button variant="primary" className="mt-6" onClick={onDone}>
        {t('activation.clarification.resubmitted.done')}
      </Button>
    </div>
  );
};
